// extracted by mini-css-extract-plugin
module.exports = {"QuizCreator":"QuizCreator_QuizCreator__2ezyw"};